import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Container from '@mui/material/Container';
import Card from '@mui/material/Card'
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack'
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';

import { DropdownInput } from './common';
import { selectUser } from '../Auth/selector';
import { selectCreateJobError, selectCreateJobSuccessful } from './selector';
import { createJob } from './action';
import { setCreateJobSuccess } from './slice';

const JobCreationForm = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const authenticatedUser = useSelector(selectUser);
  const formSubmitError = useSelector(selectCreateJobError);
  const jobCreationSuccessful = useSelector(selectCreateJobSuccessful);
  console.log({ jobCreationSuccessful });

  const [formData, setFormData] = useState({
    petType: null,
    petSize: null,
    petName: '',
    currency: null,
    amount: 0,
    address: '',
    passportSubmitted: false,
    driversLicenseSubmitted: false,
    policeCheck: false,
    completedPreviousJobs: false,
    withinTenKms: false,
  });
  const [formEntryError, setFormEntryError] = useState({
    petTypeError: null,
    petSizeError: null,
    petNameError: null,
    currencyError: null,
    amountError: null,
    addressError: null,
  });

  const petTypes = [
    { label: 'Cat', value: 'cat' },
    { label: 'Dog', value: 'dog' },
  ];

  const petSizes = [
    { label: 'Big', value: 'big' },
    { label: 'Small', value: 'small' },
  ];

  const currency = [
    { label: 'AUD', value: 'AUD' },
  ];

  const handleOnChange = (key, value) => {
    const errorKey = `${key}Error`;
    setFormEntryError({
      ...formEntryError,
      [errorKey]: null,
    });
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const validateFormData = () => {
    const error = {
      petTypeError: null,
      petSizeError: null,
      petNameError: null,
      currencyError: null,
      amountError: null,
      addressError: null,
    };
    if (!formData.petType) {
      error.petTypeError = 'Pet type is required';
    }
    // if (!formData.petSize) {
    //   error.petSizeError = 'Pet size is required';
    // }
    if (!formData.petName) {
      error.petNameError = 'Pet name is required';
    }
    // if (!formData.currency) {
    //   error.currencyError = 'Currency is required';
    // }
    // if (formData.amount <= 0) {
    //   error.amountError = 'Amount must be greater than 0';
    // }
    // if (!formData.address) {
    //   error.addressError = 'Address is required';
    // }
    setFormEntryError(error);
    return Object.keys(error).reduce(
      (prevVal, key) => prevVal && error[key] === null,
      true,
    );
  };

  const handleCheckboxOnChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.checked,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const isDataValid = validateFormData();
    if (!isDataValid) return;
    dispatch(createJob(formData, authenticatedUser));
  };

  const handleSuccessModalClose = () => {
    dispatch(setCreateJobSuccess(false));
    history.push('/dashboard');
  };

  return (


    <Container
      component="main"
      maxWidth="md"
      sx={{
        height: 'calc(100vh - 100px)',
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: '100px auto',
        pt: 10,
      }}
    >

      <Modal
        open={jobCreationSuccessful}
        onClose={handleSuccessModalClose}
        aria-labelledby="job-creation-successful-modal"
        aria-describedby="job-creation-successful-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="logout-modal" variant="h6" component="h2">
            Job successfully created!
          </Typography>
          <Typography id="logout-modal-description" sx={{ mt: 2 }}>
            You are on your way to be matched to a sitter!
          </Typography>
        </Box>
      </Modal>


      <Stack>
      <Typography
        textAlign="center"
        variant="h5"
        component="h1"
        // sx={{ gridColumnStart: 1, gridColumnEnd: 2 }}
      >
        Get a trusted sitter for your pet instantly!
      </Typography>
        </Stack>
      <Card sx={{ paddingX: "2rem", paddingY: "3rem" }}>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '2em',
          mt: 2,
        }}
      >
        <Box component="div" sx={{ '&>*:not(div:first-of-type)': { mt: 1.5 } }}>
          <DropdownInput
            id="pet-type-input"
            options={petTypes}
            onChange={(_, selectedValue) => handleOnChange('petType', selectedValue)}
            textBoxLabel="Pet Type"
            textBoxError={formEntryError.petTypeError !== null}
            textBoxHelperText={formEntryError.petTypeError}
          />
          <DropdownInput
            id="pet-size-input"
            options={petSizes}
            onChange={(_, selectedValue) => handleOnChange('petSize', selectedValue)}
            textBoxLabel="Pet Size"
            textBoxError={formEntryError.petSizeError !== null}
            textBoxHelperText={formEntryError.petSizeError}
          />
          <TextField
            fullWidth
            id="pet-name-input"
            name="petName"
            label="Pet Name"
            value={formData.petName}
            onChange={e => handleOnChange(e.target.name, e.target.value)}
            error={formEntryError.petNameError !== null}
            helperText={formEntryError.petNameError}
          />
          <DropdownInput
            id="currency-type-input"
            options={currency}
            onChange={(_, selectedValue) => handleOnChange('currency', selectedValue)}
            textBoxLabel="Currency"
            textBoxError={formEntryError.currencyError !== null}
            textBoxHelperText={formEntryError.currencyError}
          />
          <TextField
            fullWidth
            id="currency-value-input"
            name="amount"
            label="Amount"
            type="number"
            value={formData.amount}
            InputProps={{ inputProps: { min: 0 } }}
            onChange={e => handleOnChange(e.target.name, parseInt(e.target.value, 10))}
            error={formEntryError.amountError !== null}
            helperText={formEntryError.amountError}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Submit
          </Button>
        </Box>
        <Box component="div" sx={{ '&>*:not(div:first-of-type)': { mt: 1.5 } }}>
          <TextField
            id="address-input"
            label="Main address"
            name="address"
            multiline
            rows={3}
            fullWidth
            value={formData.address}
            onChange={e => handleOnChange(e.target.name, e.target.value)}
            error={formEntryError.addressError !== null}
            helperText={formEntryError.addressError}
          />
          <Typography variant="h6" component="p">
            Pet Sitter Preferences
          </Typography>
          <FormGroup sx={{ mt: 0 }}>
            <FormControlLabel
              control={
                <Checkbox
                  name="passportSubmitted"
                  checked={formData.passportSubmitted}
                  value={formData.passportSubmitted}
                  onChange={handleCheckboxOnChange}
                />}
              label="Passport submitted"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="driversLicenseSubmitted"
                  checked={formData.driversLicenseSubmitted}
                  value={formData.driversLicenseSubmitted}
                  onChange={handleCheckboxOnChange}
                />}
              label="Driver’s License Submitted"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="policeCheck"
                  checked={formData.policeCheck}
                  value={formData.policeCheck}
                  onChange={handleCheckboxOnChange}
                />}
              label="Police Check"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="completedPreviousJobs"
                  checked={formData.completedPreviousJobs}
                  value={formData.completedPreviousJobs}
                  onChange={handleCheckboxOnChange}
                />}
              label="Completed Previous jobs"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="withinTenKms"
                  checked={formData.withinTenKms}
                  value={formData.withinTenKms}
                  onChange={handleCheckboxOnChange}
                />}
              label="10 KM Away"
            />
          </FormGroup>
          {formSubmitError && (
            <Alert severity="error" sx={{ mt: 1 }}>{formSubmitError}</Alert>
          )}
        </Box>
      </Box>
      </Card>
    </Container>

  );
};

export default JobCreationForm;
